import axiosAuth from '@/axiosMain';

const state = {
  features: null,
};

const getters = {
  features({ features }) {
    return features;
  },
  isFeatureEnabled: (state, getters) => (name) => {
    return getters.features[name];
  },
  isAnnualSequestrationFieldEnabled(state, getters) {
    return getters.isFeatureEnabled('annual-sequestration-field');
  },
};

const mutations = {
  setFeatures(state, data) {
    state.features = data;
  },
};

const actions = {
  async getFeatureFlags({ commit, getters }) {
    const { data: featureflags } = await axiosAuth.get('/feature-flags');

    commit('setFeatures', featureflags);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
